import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    // marginLeft: theme.spacing.unit,
    // marginRight: theme.spacing.unit,
    // width: 1000,
  },
  menu: {
    width: 200,
  },
});

class LocationField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: ''
    }
    this.autocomplete = null;
    this.handlePlaceChanged = this.handlePlaceChanged.bind(this);
  }

  componentDidMount() {
    this.script = document.createElement('script')
    this.script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAaeJ2wH4DQteG6B6iUfdeWguex1QPM6BU&libraries=places'
    this.script.async = 1
    this.script.defer = 1
    this.script.onload = () => this.initAutocomplete()

    document.body.appendChild(this.script)
  }

  initAutocomplete() {
    const google = window.google
    console.log('Google Maps Loaded')
    this.autocomplete = new google.maps.places.Autocomplete(document.getElementById(this.props.input.name), {types: ['geocode']})
    this.autocomplete.addListener('place_changed', this.handlePlaceChanged)
  }

  componentWillUnmount() {
    const google = window.google
    google.maps.event.clearListeners(this.autocomplete, 'place_changed');
  }

  handlePlaceChanged() {
    let data = {
      address: this.autocomplete.getPlace().formatted_address,
      location: {
        coordinates: [this.autocomplete.getPlace().geometry.location.lng(), this.autocomplete.getPlace().geometry.location.lat()]
      }
    }

    this.props.input.onChange(data)
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  render() {
    const {classes} = this.props;

    return (
        <div>
          <TextField
              style={{width: "100%"}}
              id={this.props.input.name}
              label={this.props.label}
              name={this.props.input.name}
              className={classes.textField}
              {...this.props.input}
              value={typeof this.props.input.value === 'object' ? this.props.input.value.address : this.props.input.value}
              // margin="normal"
          />
          {this.props.meta.touched &&
          (this.props.meta.error && <p className="error-text">{this.props.meta.error}</p>)}
        </div>

    );
  }
}

LocationField.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LocationField);